/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 * AccountInfo Delivery styling
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.11.0
 */

import styled from 'styled-components';

import { colors } from '@theme/index';

interface IAccountDeliveryTypeStyled {
    isConnectButtonVisible?: boolean;
    withInfoBlock?: boolean;
}

export const InfoTextStyled = styled.p`
    margin: 0;
    margin-bottom: 12px;
`;

export const AccountInfoDeliveryStyled = styled.div.attrs({
    className: 'account-info-delivery',
})`
    max-width: 600px;

    .delivery__address-field {
        display: flex;
        align-items: center;

        .form-field {
            width: 100%;
        }
    }

    .delivery__address-field-checkbox {
        display: flex;
        width: fit-content;
    }

    .inquiry-link__button {
        margin-left: 0.3em;
    }
`;

export const AccountDeliveryInfoTitle = styled.h5`
    margin: 0;
    margin-bottom: 12px;
`;

export const AccountDeliveryTypeStyled = styled.section<IAccountDeliveryTypeStyled>`
    border: 1px solid ${colors.borderColorLight};
    padding: 16px;
    margin: 24px 0;

    &:first-child {
        margin-top: 0;
    }

    &:nth-of-type(even) {
        margin-top: ${(props) => (props.withInfoBlock ? '24px' : 0)};
        margin-bottom: 0;
    }

    &.delivery-last-type {
        margin-bottom: 24px;
    }

    .delivery__edm-field {
        margin-bottom: ${(props) => (!!props.isConnectButtonVisible ? 0 : '8px')};
    }
`;

export const AccountDeliveryEdmInfoStyled = styled.div`
    display: grid;
    grid-template-rows: repeat(3, max-content);
    padding-right: 65px;
`;

export const EdmInfoTitleStyled = styled.h5`
    margin: 0;
    margin-bottom: 4px;
`;

export const EdmInfoTextStyled = styled.p`
    margin: 0;
    margin-bottom: 8px;
`;

export const EdmInfoLinkContainerStyled = styled.div`
    display: flex;
    align-items: baseline;
    height: 20px;
`;

export const EdmInfoLinkStyled = styled.h5`
    display: inline-block;
    margin: 0;
    margin-right: 8px;
    text-decoration: none;
    color: ${colors.textLinkColor};
`;

export const EdmSettingsInfoStyled = styled.p`
    margin-top: 6px;
    margin-bottom: 8px;
    text-align: justify;
`;
